import React from 'react';
import PropTypes from 'prop-types';

import { destroy } from '@api/v4/resources/conversion_presets';

const PresetTableRow = ({
  id,
  name,
  aspectWidth,
  aspectHeight,
  width,
  height,
  format,
  onRemove,
}) => {
  const remove = async () => {
    await destroy(id);
    onRemove();
  };

  return (
    <li>
      <span>{name}</span>
      <span>{aspectWidth && aspectHeight && `${aspectWidth}:${aspectHeight}`}</span>
      <span>{width}</span>
      <span>{height}</span>
      <span>{format || 'Allow User To Select'}</span>
      <span>
        <button
          type="button"
          onClick={remove}
          data-testid="remove-button"
        >
          <span className="bff-trash" />
        </button>
      </span>
    </li>
  );
};

PresetTableRow.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  aspectWidth: PropTypes.number,
  aspectHeight: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  format: PropTypes.string,
  onRemove: PropTypes.func,
};

PresetTableRow.defaultProps = {
  width: null,
  height: null,
  format: null,
  aspectWidth: null,
  aspectHeight: null,
  onRemove: () => {},
};

export default PresetTableRow;
